import { evaluateCondition } from "./conditions.js";
export function getQuestionById(quiz, questionId) {
    return quiz.questions.find((question) => question.id === questionId);
}
export function getNextQuestionId(quiz, questionId, answers) {
    const question = getQuestionById(quiz, questionId);
    if (!question)
        return undefined;
    for (const rule of quiz.navigationRules ?? []) {
        if (rule.from !== questionId)
            continue;
        if (evaluateCondition(rule.when, { answers }))
            return rule.next;
    }
    const answerId = answers[questionId];
    const answer = question.answers.find((candidate) => candidate.id === answerId);
    if (answer?.next)
        return answer.next;
    const currentIndex = quiz.questions.findIndex((candidate) => candidate.id === questionId);
    const nextQuestion = quiz.questions[currentIndex + 1];
    return nextQuestion?.id ?? "__end__";
}
export function deriveRoute(quiz, answers) {
    const visitedQuestionIds = [];
    const seen = new Set();
    let current = quiz.startQuestionId;
    while (current && current !== "__end__") {
        if (seen.has(current)) {
            throw new Error(`Navigation loop detected at question "${current}" in quiz "${quiz.slug}"`);
        }
        seen.add(current);
        visitedQuestionIds.push(current);
        if (!answers[current]) {
            return {
                visitedQuestionIds,
                staleQuestionIds: Object.keys(answers).filter((id) => !seen.has(id)),
                currentQuestionId: current,
                isComplete: false
            };
        }
        current = getNextQuestionId(quiz, current, answers);
    }
    return {
        visitedQuestionIds,
        staleQuestionIds: Object.keys(answers).filter((id) => !seen.has(id)),
        isComplete: true
    };
}
export function pruneStaleAnswers(quiz, answers) {
    const route = deriveRoute(quiz, answers);
    if (route.staleQuestionIds.length === 0)
        return { ...answers };
    const validIds = new Set(route.visitedQuestionIds);
    return Object.fromEntries(Object.entries(answers).filter(([questionId]) => validIds.has(questionId)));
}
export function updateAnswer(quiz, answers, questionId, answerId) {
    return pruneStaleAnswers(quiz, { ...answers, [questionId]: answerId });
}
